// 智慧巡检
import Log from '../view/log'
import InspectionDeviceTypeManage from '../view/Inspection/InspectionDeviceType/InspectionDeviceTypeManage'
import InspectionDeviceTypeAdd from '../view/Inspection/InspectionDeviceType/InspectionDeviceTypeAdd'
import InspectionDeviceTypeModify from '../view/Inspection/InspectionDeviceType/InspectionDeviceTypeModify'
import InspectionDeviceManage from '../view/Inspection/InspectionDevice/InspectionDeviceManage'
import InspectionDeviceAdd from '../view/Inspection/InspectionDevice/InspectionDeviceAdd'
import InspectionDeviceModify from '../view/Inspection/InspectionDevice/InspectionDeviceModify'
import InspectionPersonManage from '../view/Inspection/InspectionPerson/InspectionPersonManage'
import InspectionPersonAdd from '../view/Inspection/InspectionPerson/InspectionPersonAdd'
import InspectionPersonModify from '../view/Inspection/InspectionPerson/InspectionPersonModify'
import InspectionTeamManage from '../view/Inspection/InspectionTeamManage/InspectionTeamManage'
import InspectionTeamAdd from '../view/Inspection/InspectionTeamManage/InspectionTeamAdd'
import InspectionTeamModify from '../view/Inspection/InspectionTeamManage/InspectionTeamModify'
import InspectionPlanManage from '../view/Inspection/InspectionPlan/InspectionPlanManage'
import InspectionPlanAdd from '../view/Inspection/InspectionPlan/InspectionPlanAdd'
import InspectionPlanModify from '../view/Inspection/InspectionPlan/InspectionPlanModify'
import InspectionTaskManage from '../view/Inspection/InspectionTask/InspectionTaskManage'
import InspectionRecord from '../view/Inspection/InspectionRecord/InspectionRecord'
import InspectionReport from '../view/Inspection/InspectionReport/InspectionReport'
import AssetManage from '../view/Inspection/AssetManagement/AssetManage'
import InspectionNav from '../view/Inspection/InspectionNav'

export default [
  /* 智慧巡检 */
  {
    path: '/inspection_device_type_manage',
    name: 'inspection-device-type-manage',
    components: {
      default: InspectionNav,
      a: InspectionDeviceTypeManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/inspection_device_type_add',
    name: 'inspection-device-type-add',
    components: {
      default: InspectionNav,
      a: InspectionDeviceTypeAdd
    }
  },
  {
    path: '/inspection_device_type_modify',
    name: 'inspection-device-type-modify',
    components: {
      default: InspectionNav,
      a: InspectionDeviceTypeModify
    }
  },
  {
    path: '/inspection_device_manage',
    name: 'inspection-device-manage',
    components: {
      default: InspectionNav,
      a: InspectionDeviceManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/inspection_device_add',
    name: 'inspection-device-add',
    components: {
      default: InspectionNav,
      a: InspectionDeviceAdd
    }
  },
  {
    path: '/inspection_device_modify/:id',
    name: 'inspection-device-modify',
    components: {
      default: InspectionNav,
      a: InspectionDeviceModify
    }
  },
  {
    path: '/inspection_person_manage',
    name: 'inspection-person-manage',
    components: {
      default: InspectionNav,
      a: InspectionPersonManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/inspection_person_add',
    name: 'inspection-person-add',
    components: {
      default: InspectionNav,
      a: InspectionPersonAdd
    }
  },
  {
    path: '/inspection_person_modify/:id',
    name: 'inspection-person-modify',
    components: {
      default: InspectionNav,
      a: InspectionPersonModify
    }
  },
  {
    path: '/inspection_team_manage',
    name: 'inspection-team-manage',
    components: {
      default: InspectionNav,
      a: InspectionTeamManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/inspection_team_add',
    name: 'inspection-team-add',
    components: {
      default: InspectionNav,
      a: InspectionTeamAdd
    }
  },
  {
    path: '/inspection_team_modify/:id',
    name: 'inspection-team-modify',
    components: {
      default: InspectionNav,
      a: InspectionTeamModify
    }
  },
  {
    path: '/inspection_plan_manage',
    name: 'inspection-plan-manage',
    components: {
      default: InspectionNav,
      a: InspectionPlanManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/inspection_plan_add',
    name: 'inspection-plan-add',
    components: {
      default: InspectionNav,
      a: InspectionPlanAdd
    }
  },
  {
    path: '/inspection_plan_modify/:id',
    name: 'inspection-plan-modify',
    components: {
      default: InspectionNav,
      a: InspectionPlanModify
    }
  },
  {
    path: '/inspection_task_manage',
    name: 'inspection-task-manage',
    components: {
      default: InspectionNav,
      a: InspectionTaskManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/inspection_record',
    name: 'inspection-record',
    components: {
      default: InspectionNav,
      a: InspectionRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/inspection_report',
    name: 'inspection-report',
    components: {
      default: InspectionNav,
      a: InspectionReport
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/asset_manage',
    name: 'asset-manage',
    components: {
      default: InspectionNav,
      a: AssetManage
    },
    meta: {
      keepAlive: true
    }
  },
  /* 智慧巡检 */
  // 智慧巡检操作日志
  {
    path: '/inspection_log',
    name: 'inspection-log',
    components: {
      default: InspectionNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/Inspection.js